var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"alert-error",attrs:{"type":"warning","text":"","outlined":"","rounded":"","prominent":""}},[_vm._v(" Your account is still pending creation. Your uploads may be delayed until approval process is complete. ")])}
var staticRenderFns = []

export { render, staticRenderFns }